export const appGroupIdLiquidValidationFeatures = "/:app_group_id/liquid_validation/features";
